/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Deal_Provision_Apply_DefaultInputs */

const cs_deal_provision_apply_default = /** @type {(inputs: Deal_Provision_Apply_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Použít výchozí kanceláře (${i?.percent} %)`)
};

const en_deal_provision_apply_default = /** @type {(inputs: Deal_Provision_Apply_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use office default (${i?.percent}%)`)
};

/**
* | output |
* | --- |
* | "Use office default ({percent}%)" |
*
* @param {Deal_Provision_Apply_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_apply_default = /** @type {((inputs: Deal_Provision_Apply_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_Apply_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_apply_default(inputs)
	return cs_deal_provision_apply_default(inputs)
});